import type { Configuration, RedirectRequest } from "@azure/msal-browser";
import { getAuthRuntimeConfig } from "./auth/authRuntimeConfig";

// One app registration, authority and API scope serve every hostname. Affiliate sites differ only
// in the sign-in UI they render (native authentication), so tokens from the branded page and the
// Microsoft-hosted page are interchangeable and the rest of the app does not care which was used.
export const authRuntimeConfig = getAuthRuntimeConfig();

export const msalConfig: Configuration = {
  auth: {
    clientId: authRuntimeConfig.clientId,
    authority: authRuntimeConfig.authority,
    knownAuthorities: authRuntimeConfig.knownAuthorities,
    redirectUri: "/",
    postLogoutRedirectUri: "/logged-out",
  },
  system: {
    allowPlatformBroker: false, // Disables WAM Broker
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

export const loginRequest: RedirectRequest = {
  scopes: authRuntimeConfig.apiScopes,
};
